<template>
    <div class="commentdiv" id="commentdiv">
        <template v-if="false">
            <div class="hotlist">
                <div class="header">
                <div class="title">
                    精彩评论(
                    { comments.hot.length })
                </div>
                </div>
                <ul class="list">
                { hotlist }
                </ul>
            </div>
        </template>
        <div class="clist">
            <div class="header">
                <div class="title">
                全部评论(
                { comments.total })
            </div>
        </div>
            <ul class="list liHasBorder">
            { lists }
            { nextload }
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: "comment"
}
</script>
